angular.module('leanlaw').controller('MatterInfoCtrl', ['$scope', '$rootScope', '$q', '$state', 'matterTagsService', 'alerts', 'leanLawApi', 'tippy', '$timeout', 'autosize', function ($scope, $rootScope, $q, $state, matterTagsService, alerts, leanLawApi, tippy, $timeout, autosize) {
  $scope.saving = false;
  $scope.error = false;
  $scope.operations = {
    archive: false,
    activate: false,
    delete: false,
    saving: false
  };
  $scope.enableAdding = false;
  $scope.inlineNotesEditMode = false;
  activate();
  $scope.save = save;
  $scope.cancel = cancel;
  $scope.data = {};
  $scope.isEditing = false;
  $scope.activate = function (active) {
    const term = $scope.me.terms.matter;
    if (!active) {
      bootbox.confirm(`<h4>Do you want to archive this ${term}?</h4><p>Archiving the ${term} will hide it from all users and hide any unbilled time or expenses from some pages. You can easily restore the ${term} from here if you need it again.</p>`, result => {
        if (result) {
          $scope.operations.saving = true;
          $scope.matter.activate(false).then(() => {
            alerts.success(`The ${term} was archived. You can find it again by selecting 'Show Archived'.`);
            $state.go('^');
          }).catch(err => {
            alerts.error(err);
          }).finally(() => {
            $scope.operations.saving = false;
          });
        }
      });
    } else {
      $scope.operations.saving = true;
      $scope.matter.activate(true).then(matter => {
        alerts.success(`The ${term} was restored.`);
        $scope.operations.activate = false;
        $scope.operations.archive = true;
        return $scope.assignMatterToScope(matter);
      }).catch(err => {
        alerts.error(err);
      }).finally(() => {
        $scope.operations.saving = false;
      });
    }
  };
  $scope.activateClient = function (active) {
    const term = $scope.me.terms.matter;
    let message = `<h4>Do you want to archive all the ${term}s for this client?</h4><p>Archiving will hide it from all users and hide any unbilled time or expenses from some pages. All data will be kept. You can easily restore from here if you need to.</p>`;
    let done = `The ${term}s were archived`;
    if (active) {
      message = `<h4>Do you want to restore all the ${term}s for this client?</h4>`;
      done = `The ${term}s were restored`;
    }
    bootbox.confirm(message, result => {
      if (result) {
        const all = $scope.client.matters.map(matter => leanLawApi.updateMatter({
          id: matter.id,
          body: {
            active
          }
        }));
        $q.all(all).then(() => {
          alerts.success(done);
          // See the flag check in $scope.delete above.
          $state.go($scope.me.features?.fizzyLiftingDrink ? 'matters' : 'matters-next');
        }).catch(err => {
          $scope.operations.saving = false;
          alerts.error(err);
        });
      }
    });
  };
  $scope.delete = function () {
    const term = $scope.me.terms.matter;
    bootbox.confirm(`<h4>Do you want to delete this ${term}?</h4><p>There is no activity (time entries, invoices etc) recorded for the ${term} but note that you can't undo it.`, result => {
      if (result) {
        $scope.operations.saving = true;
        $scope.matter.delete().then(() => {
          alerts.success(`The ${term} was deleted`);
          // Feature-flagged route (sc-46278): matter detail pages are
          // still served under matters-next regardless of the flag
          // (the new /matters root has no detail hierarchy of its
          // own), so which list to return to has to come from the
          // flag, not the current state name - matters.* here was a
          // leftover check for the old legacy /matters app, which no
          // longer exists.
          if ($scope.me.features?.fizzyLiftingDrink) {
            $state.go('matters');
          } else {
            $state.go('matters-next');
          }
        }).catch(err => {
          $scope.operations.saving = false;
          alerts.error(err);
        });
      }
    });
  };
  $scope.fix = function () {
    $scope.operations.saving = true;
    leanLawApi.updateMatterFolder({
      id: $scope.matter.id
    }).finally(() => {
      $scope.operations.saving = false;
    });
  };

  ///////////////////////////////////

  function activate() {
    matterTagsService.getMatterTags().then(mattertags => {
      if (!mattertags) return;
      $scope.data.matterTags = mattertags;
    });
    $scope.$parent.$watch('matter', matter => {
      if (!$scope.matter || !$scope.matter.stats) return;
      $timeout(() => {
        tippy('.tippy-avatar');
      }, 200);
      $scope.matter.stats().then(stats => {
        $scope.operations.delete = stats.deletable;
        $scope.operations.activate = !$scope.matter.active;
        $scope.operations.archive = $scope.matter.active;
        leanLawApi.getClient({
          id: matter.client.id,
          matters: 'include',
          status: 'all'
        }).then(client => {
          $scope.client = client;
          if (client.matters.length > 1) {
            $scope.operations.activateClient = $scope.operations.activate;
            $scope.operations.archiveClient = $scope.operations.archive;
          }
        });
      });
      setUpOriginationSettings();
    });
    const deactivate = $rootScope.$on('$stateChangeStart', (event, transition) => {
      if ($scope.infoForm && $scope.infoForm.$dirty) {
        $scope.unsaved = true;
        $timeout(() => {
          $scope.unsaved = false;
        }, 4000);
        event.preventDefault();
      } else {
        deactivate();
      }
    });
  }
  function save() {
    $scope.saving = true;
    if (!$scope.matter.matterTag) {
      // This is necessary for clearing out a matter tag if it was set before
      $scope.matter.matterTag = {};
    }
    $scope.matter.update().then(matter => {
      $scope.$parent.$emit('matterBillingIsDirty', false);
      $scope.saving = false;
      $scope.infoForm.$setPristine();
      return $scope.assignMatterToScope(matter);
    }).catch(err => {
      $scope.saving = false;
      alerts.error(err);
    });
  }
  function cancel() {
    $scope.isEditing = false;
    $scope.error = false;
    $scope.matter.reload().then(matter => {
      $scope.infoForm.$setPristine();
      $scope.$parent.$emit('matterBillingIsDirty', false);
      $scope.assignMatterToScope(matter);
    });
  }
  $scope.showInlineNotesEditor = () => {
    $scope.inlineNotesEditMode = true;
    $timeout(() => {
      const inlineNotesEditor = $('#inlineMatterNotesEditor');
      if (inlineNotesEditor) {
        autosize(inlineNotesEditor);
        inlineNotesEditor.focus();
      }
    }, 200);
  };
  $scope.commitInlineNotesEditing = () => {
    $scope.inlineNotesEditMode = false;
    $scope.save();
  };
  $scope.cancelInlineNotesEditing = () => {
    $scope.inlineNotesEditMode = false;
  };
  function setUpOriginationSettings() {
    const {
      originationStepDownPeriodInMonths,
      originationStepDownStart
    } = $scope.matter.billing;
    $scope.matter.billing.originationStepDownPeriodInMonths = originationStepDownPeriodInMonths || $scope.me.company.settings.report?.originationStepDownPeriodInMonths;
    $scope.matter.billing.originationStepDownStart = originationStepDownStart || $scope.matter.opened;
  }
}]);